module.exports = __webpack_public_path__ + "static/indy-avatar.744227a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/indy-avatar.svg
// module id = 202
// module chunks = 33270746189138 35783957827783